import axios from 'axios';
import { BASE_API_URL, BASE_API_URL_SECRET } from '../../app_constants';
// import { redirectToSsoLogin, removeToken } from '../authStatus';
import refreshTokenHandler from '../refreshTokenService';

const axiosInterseptor = axios.create();

const apiClient = axios.create({
  baseURL: BASE_API_URL_SECRET,
});

axiosInterseptor.interceptors.request.use(
  (config) => {
    const tokenExpirationTime = localStorage.getItem('tokenExpirationTime');
    const accessToken = localStorage.getItem('access_token');
    const newConfig = { ...config };
    if (accessToken && tokenExpirationTime) {
      newConfig.headers.set('Authorization', `Bearer ${accessToken}`);
      newConfig.baseURL = BASE_API_URL_SECRET;
    } else {
      newConfig.baseURL = BASE_API_URL;
    }
    return newConfig;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInterseptor.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    // eslint-disable-next-line no-underscore-dangle
    if (error.response?.status === 401 && !originalRequest._retry) {
      // eslint-disable-next-line no-underscore-dangle
      originalRequest._retry = true;
      try {
        const newAccessToken = await refreshTokenHandler();
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return await apiClient(originalRequest);
      } catch (refreshError) {
        console.error('Не удалось обновить токен:', refreshError);
        // removeToken();
        // redirectToSsoLogin();
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  },
);

export default axiosInterseptor;
